import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SALECLAUSE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SaleClause.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('value', 'Entity.SaleClause.Value')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
];

export const SALECLAUSE_CONFIG = {
  entityName: 'SaleClause',
  localizationKey: 'Controlling::Entity.SaleClause',
  fields: SALECLAUSE_FIELDS,
  permission: 'ControllingLiquidations.SaleClauses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
